import React, { Component } from 'react'
import { Col, Row } from '../../../../../../SPRINTA/atoms/Grid'
import BoxAccordion from '../../../../../../SPRINTA/atoms/BoxAccordion'
import AspectRatio from '../../../../../../SPRINTA/atoms/AspectRatio'
import Button from '../../../../../../SPRINTA/atoms/Button'
import FontIcon from '../../../../../../SPRINTA/atoms/FontIcon'
import { numberFormat } from '../../../../../../SPRINTA/helpers/Formatter'
import ImageLightBox from '../../../../../../SPRINTA/third-party/ImageLightBox'

import s from './style.css'

export default class Room extends Component {
   state = {
      fullDescription: false,
      images: [],
      lightBox: false,
      indexImageLightBox: null
   }

   componentWillMount() {
      let images = []
      this.props.data.images.forEach( (element, key) => {
         let image = `${window.config.url_event_extras_images}${element.image}`
         images.push(image)
      })
      
      this.setState({
         images
      })
   }

   openImage(key) {
      this.setState({
          indexImageLightBox: key,
          lightBox: true
      })
   }

   render() {
      const data = this.props.data
      const image = data.images[0] ? `${window.config.url_event_extras_images}${data.images[0].image}` : null
      
      let { guest_value, value } = data
      guest_value = parseFloat(guest_value)
      value = parseFloat(value)
      let guests = parseInt(this.props.guests, 10) - 1
      
      const price = (guests * guest_value) + value



      return (
         <div>
            <Row>
               <Col size="2">
                  <div onClick={() => this.openImage(0)} style={{cursor: 'pointer'}}>
                     <AspectRatio ratio='1x1' image={image}/>
                  </div>
               </Col>
               <Col size='10'>
                  <Row>
                     <Col size="8">
                        <div style={{fontSize: '14px'}}>
                           <b>{data.label}</b> <br />
                           <BoxAccordion style={{color: '#4a4a4a', fontSize: '14px', minHeight: '80px'}} height='100px' show={this.state.fullDescription}>
                              {data.description}
                           </BoxAccordion>
                        </div>
                        <div className={s.showmore} onClick={() => this.setState({
                           fullDescription: !this.state.fullDescription
                        })}>
                           {this.state.fullDescription ? `ver menos` : `ver mais`}
                        </div>
                     </Col>
                     <Col size="4">
                        <div className={s.price}>
                           R$ {numberFormat(price, 2, ',', '.')}
                        </div>
                        <div className={s.priceinfo}>
                           para {this.props.guests} {this.props.guests > 1 ? `hóspedes` : 'hóspede'}
                        </div>
                        <Button inline theme='primary' onClick={() => this.props.handleChosen()}>Reservar este</Button>
                     </Col>
                  </Row>

                  <Row>
                     <Col>
                        <ul className={s.infoitems}>
                           <li>
                              <FontIcon name="admin_hotel" />
                              <span>
                                 {data.max_guests}
                              </span>
                           </li>
                           <li>
                              <FontIcon name="admin_calendar" />
                              <span>
                                 {data.daily_rate}
                              </span>
                           </li>
                        </ul>
                     </Col>
                  </Row>
               </Col>
            </Row>

            <ImageLightBox handleClose={() => {
                           this.setState({
                              lightBox: false
                           })
                     }}
                     isOpen={this.state.lightBox}
                     images={this.state.images}
                     photoIndex={this.state.indexImageLightBox}/>
         </div>
      )
   }

}


// WEBPACK FOOTER //
// ./src/components/templates/Event/ListHotel/Accommodation/Room/index.js